<form [formGroup]="filterForm" class="form-custom">
  <mat-form-field class="lcs-date-range-input-form-field">
    <lcs-date-range-picker-input
      class="lcs-date-range-input-field"
      [dateRangePickerOptions]="dateRangePickerOptions"
      [initialContentFormValue]="initialDateRange"
      >
      <input
        lcsStartDate
        class="lcsDate"
        placeholder="From Date"
        formControlName="fromDate"
        [name]="'fromDate'"
        autocomplete="off" />
        <input lcsEndDate placeholder="To Date" formControlName="toDate" [name]="'toDate'" autocomplete="off"
        /></lcs-date-range-picker-input>
      </mat-form-field>
      @if (!isFaxRegister) {
        <mat-form-field>
          <input
            autocomplete="off"
            type="text"
            formControlName="callDisposition"
            id="callDisposition"
            lcsStaticSelect
            placeholder="Call Disposition"
            [lcsSingleSelect]="callDispositionSelect"
            [lcsStaticSelectValue]="this.filterForm.get('callDisposition')?.value"
            />
            <lcs-static-select #callDispositionSelect [isIncludeEmptyOption]="true">
              <lcs-option [value]="null">{{ '' }}</lcs-option>
              @for (callDispositionType of callDispositionTypes; track callDispositionType) {
                <lcs-option [value]="callDispositionType">
                  {{ callDispositionType === 'QueueCallBack'
                  ? 'Callback'
                  : callDispositionType }}
                </lcs-option>
              }
            </lcs-static-select>
          </mat-form-field>
        }
        @if (!isFaxRegister) {
          <mat-form-field>
            <input
              autocomplete="off"
              type="text"
              formControlName="callDirection"
              id="callDirection"
              lcsStaticSelect
              placeholder="Call Direction"
              [lcsSingleSelect]="callDirectionSelect"
              [lcsStaticSelectValue]="this.filterForm.get('callDirection')?.value"
              />
              <lcs-static-select #callDirectionSelect>
                <lcs-option>{{ '' }}</lcs-option>
                @for (callDirectionTypes of callDirectionTypes; track callDirectionTypes) {
                  <lcs-option [value]="callDirectionTypes">
                    {{ callDirectionTypes | addSpaces }}
                  </lcs-option>
                }
              </lcs-static-select>
            </mat-form-field>
          }
          @if (isSystemUser && isOnCallHistoryPage) {
            <mat-form-field>
              <input
                matInput
                autocomplete="off"
                type="text"
                id="providerId"
                formControlName="providerId"
                placeholder="Provider"
                lcsStaticSelect
                [lcsSingleSelect]="providerSelect"
                [lcsStaticSelectValue]="this.filterForm.get('providerId')?.value"
                [openPanelOnFocus]="true"
                (search)="providerSearch($event)"
                (reset)="providerReset()"
                />
                <lcs-static-select
                  #providerSelect
                  [displayWith]="providerDisplayWith"
                  [autoActiveFirstOption]="true"
                  [isIncludeEmptyOption]="true"
                  >
                  <lcs-option [value]="null">{{ '' }}</lcs-option>
                  @for (provider of providers; track provider) {
                    <lcs-option [value]="provider">
                      {{ provider }}
                    </lcs-option>
                  }
                </lcs-static-select>
              </mat-form-field>
            }

            @if (isOnCallHistoryPage) {
              <lcs-advanced-multi-select
                [headerText]="extensionAndGroupEntityName"
                class="extension-and-group-call-history"
                [triggerConfig]="triggerConfig()"
                [datasources]="datasources()"
                [hasRestoreDefaults]="false"
                (init)="onInit($event)"
                (save)="onSave($event)"
                (search)="onSearch($event)"
                (openDialog)="onOpen($event)"
                (selectedItemsChange)="onSelectedItemsChange($event)"
                (close)="onClose($event)"
                >
                <ng-template let-context advancedMultiSelectItemRowDisplay>
                  <lcs-advanced-multi-select-item [context]="context" [item]="context.item" [selected]="context.selected">
                    <div class="item-label">
                      @if (context.position === 'right') {
                        <mat-icon>
                          {{ context.item.type === 'extension' ? 'phone' : 'group' }}
                        </mat-icon>
                      }
                      {{ aggregateDisplayWithFn(context.item) }}
                    </div>
                  </lcs-advanced-multi-select-item>
                </ng-template>
              </lcs-advanced-multi-select>
            }

            <!-- TODO Add call duration filter -->
            <!-- <div class="duration-filter-field">
            <div class="filter-label">
              <mat-label>Filter by Duration</mat-label>
            </div>
            <div class="duration-form-field">
              <input type="number" matInput name="fromDuration" formControlName="fromDuration" placeholder="From" class="duration-input" />
              <span class="duration-separator">-</span>
              <input type="number" matInput name="toDuration" formControlName="toDuration" placeholder="To" class="duration-input" />
            </div>
          </div> -->
        </form>
